import apiClient from '../../clients/apiClient';

export const TaskChat = (setTasks, setFilteredTasks, setMessages, taskId, navigate) => {
    const firstTaskChatMessage = (message, task_name) => {
        apiClient.post('/create-task', { message, task_name }).then(({ data }) => {
            setTasks((prevTask) => [data.task, ...prevTask]);
            setFilteredTasks((prevTask) => [data.task, ...prevTask]);
            navigate(`/t/${data.task.id}`);
            // setCurrentTask(data.task.id);
            setMessages(() => [...data.task.messages]);
        });
    }

    const sendMessage = (message) => {
        apiClient.post('/add-conversation-to-task', {
            task_id: taskId,
            message: message,
        }).then(({ data }) => {
            console.log('[WebSocket] message sent to backend', data);
            setTasks((prevTasks) => {
                return prevTasks.map((task) => {
                    if (task.id === taskId) {
                        return { ...task, messages: [...task.messages, data.message] };
                    }
                    return task;
                });
            })
            setFilteredTasks((prevTasks) => {
                return prevTasks.map((task) => {
                    if (task.id === taskId) {
                        return { ...task, messages: [...task.messages, data.message] };
                    }
                    return task;
                });
            })
            setMessages((prevMessages) => [...prevMessages, data.message]);
        })
    }

    const filterTasks = (tasks, searchTerm) => {
        searchTerm = searchTerm.trim();
        if (searchTerm.length < 3) {
            setFilteredTasks(tasks);
            return;
        }
        
        apiClient.post('/search-task', {
            search_pattern: searchTerm,
        }).then(({ data }) => {
            setFilteredTasks(data.tasks);
        });
    }

    return {
        firstTaskChatMessage,
        sendMessage,
        filterTasks,
    }
}
    